/**
* 系统的登录页面
* <!--粒子效果 属性 vue-particles前面有任何东西都会失效 https://developer.aliyun.com/article/851204 -->
*/
<template>
	<div>
		<vue-particles  color="#FFF" :particleOpacity="0.7" :particlesNumber="60" shapeType="circle" :particleSize="4"
			linesColor="#FFF" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
			:moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" style="z-index: 10;">
		</vue-particles>

		<div class="login-container">

			<img src="../assets/login_bg01.jpg" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; object-fit: cover;" />

			<!-- 数据加载提示框 -->
			<van-overlay :show="loadingData" @click="show = false">
				<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
					<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
				</div>
			</van-overlay>

			<div class="login-box" style="z-index: 100;">
				<h2>Login</h2>
				<form @submit.prevent="login">
					<div class="form-group">
						<label for="username">Username:</label>
						<input type="text" id="username" v-model="username" placeholder="Enter your username"
							required />
					</div>
					<div class="form-group">
						<label for="password">Password:</label>
						<input type="password" id="password" v-model="password" placeholder="Enter your password"
							required />
					</div>
					<button type="submit" click="login()">Login</button>
				</form>
			</div>
		</div>

	</div>

</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted

	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {
			//----------------------------------这里是正常的逻辑--------------------------------------------------
			// 在生命周期钩子中获取路由参数

			const token = Cookies.get("token");
			if (token) {
				//跳转到分销
				this.$router.push({ //跳转到首页
					path: '/Home',
					query: {}
				});
				console.log("有token 直接去首页");
			} else {
				console.log("没有有token");
			}

			//-------------------------------------这里是测试的逻辑---------------------------------------------------------------------
			// this.$router.push({
			// 	//默认跳转到社区页面
			// 	//path: 'community/198626/296358/zh/296358'
			// 	//path: 'community/230514/497899',
			// 	//path: 'community/198626/296358/296358'

			// 	//path: 'communityToys/25129/296358'//默认跳转到社区玩具页面

			// 	//path: 'communityToys/104512/273431'
			// 	//path: 'communityToys/104583/264352'
			// 	//path: 'communityToys/106609/266760' //二代锁公投页面
			// 	//path: 'communityToys/107503/242190'//不允许游客投票的三代锁界面

			// 	//path: 'commodity/51'//默认跳转到商品详情

			// 	//path: 'register'//默认跳转到注册页面
			// 	//path: '/download'//跳转到下载页面
			// 	//path: '/deleteAccount'//删除账号
			// 	// path: '/test'//默认跳转到测试页面
			// 	//path: '/QIUIPrivacyPolicy' ,//隐私政策

			// 	// path: '/VipExchange' //VIP兑换
			// 	// path: '/AmapH5' //高德地图
			// 	// path: 'gen3Country'//跳转到三代锁支持购买国家的页面
			// 	//path: 'VoiceRoom/db117f4ad340722d1ee6467bbed1cd2d/霸王龙' ,//直播间的分享 (宽图)
			// 	path: 'VoiceRoom/6d11febf43518c24de8646f105df7dad/霸王龙' ,//直播间的分享 (长图)


			// 	//path: '/warehouse' //入库查询
			// 	// path: '/WindControlHome' //风控首页
			// 	// path: '/WindControlInfo' //风控详情
			// 	// path: '/AfterSalesHome' ,//售后首页
			// 	// path: '/AfterSalesInfo' //售后详情
			// 	// path: '/AfterSalesAddHome', //添加售后首页
			// 	// path: '/AfterSalesAdd' ,//添加售后

			// 	//path: '/Home', //整个页面的首页
			// 	//path: '/Login', //整个页面的登录

			// });

		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				username: '',
				password: '',
			};
		},
		methods: {
			login() {
				this.loadingData = true;

				axios.post(this.$p_url + '/afterSale/H5/login', {
						phone: this.username,
						pwd: this.password,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("登录的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							Cookies.set("token", response.data.data.token, {
								expires: 1
							});
							console.log("缓存的token：", Cookies.get("token"))
							
							Cookies.set("uid", response.data.data.uid, {
								expires: 1
							});
							console.log("缓存的uid：", Cookies.get("uid"))
							
							this.$router.push({ //跳转到首页
								path: '/Home',
								query: {}
							});
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
		}
	};
</script>

<style scoped>
	#particles-js {
		width: 100%;
		height: calc(100% - 100px);
		position: absolute;
	}

	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f2f2f2;
	}

	.login-box {
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}

	h2 {
		text-align: center;
		color: #333;
	}

	form {
		display: flex;
		flex-direction: column;
	}

	.form-group {
		margin-bottom: 15px;
	}

	label {
		font-weight: bold;
		margin-bottom: 5px;
		color: #555;
	}

	/* 在<style scoped>中添加以下样式 */
	input {
		padding: 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		width: calc(100% - 20px);
		/* 通过减去 padding 的大小来避免重叠 */
		margin-bottom: 10px;
		/* 添加底部间距，避免与下一个元素重叠 */
	}


	button {
		padding: 10px;
		background-color: #4caf50;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	button:hover {
		background-color: #45a049;
	}
</style>